/**
 * Chart documentation shown behind the info icon on the Funnels dashboard.
 *
 * Keys match the chart link property names in `MopaFunnelsComponent`; the
 * `dashboard` key is the dashboard-level text, moved verbatim out of
 * `MopaFunnelsComponent.getFunnelsDocumentation()`.
 */
export const MopaFunnelsChartDocs = {
    dashboard: `<h1>Wykresy w Dashboardzie</h1>

  <h2>Master</h2>
  <p>
    Master funnel służy do tego, aby sprawdzić aktywność w grze high levelowo.<br>
    Master funnel został zdefiniowany na bazie pierwszego wejścia do lokacji. Eventy są posortowane i pofiltrowane w taki sposób, aby odwzorowywały dominujący sposób przechodzenia przez grę.<br>
    Zbiory lokacji, w których nie potrafiliśmy znaleźć dominującej kolejności, zostały pominięte
    (dlatego np. w Eni2 nie ma maze'ów itp).<br>
    Zostało to wyznaczone algorytmicznie dla każdej przygody.
  </p>

  <h3>Dlaczego na wykresie następny step ma więcej cnt niż poprzedni?</h3>
  <p><strong>TODO</strong></p>

  <h2>Details</h2>
  <p>
    Kiedy chcemy zdiggować aktywność userów, czyli dowiedzieć się, co się działo w trakcie wybranego stepu (lub stepów), możemy wykorzystać sekcję z wykresami <strong>Details</strong>.<br>
    Wykres Details pokazuje eventy zgłoszone przez userów w ramach wybranych stepów, posortowanych malejąco.
  </p>

  <p>
    Aby wybrać konkretny Master step, wykorzystaj filtr <strong>MASTER FUNNEL STEP ID</strong>.<br>
    Master step jest przypisany do eventów w taki sposób, że gdy zostanie zaraportowany event z jakimkolwiek master stepem,
    to wszystkie następne eventy "należą" do tego master stepu.
  </p>

  <p>
    Widok <strong>Details</strong> może także filtrować po <code>event_name</code> oraz <code>screen_name</code>.<br>
    Możemy też ograniczyć liczbę wyświetlanych stepów filtrem <strong>LIMIT DETAILS STEPS</strong>.
  </p>

  <h3>DETAILS EVENTS COUNT STRATEGY</h3>
  <p>
    Możemy wybrać sposób zliczania eventów:
  </p>
  <ul>
    <li><strong>local</strong> – liczymy county eventów w wybranych master stepach</li>
    <li><strong>total</strong> – liczymy county eventów w całej przygodzie</li>
  </ul>

  <h3>DETAILS GROUP OUTLIERS INTO 'OTHER' STEP</h3>
  <p>
    Śmieci zostaną umieszczone w buckecie <strong>Other</strong> – można wybrać 4 rodzaje grupowania.<br>
    Możemy zdecydować o tym, co zaliczamy do śmieci:
  </p>
  <ul>
    <li>brak grupowania</li>
    <li>
      <strong>total adventure count based</strong> – jeżeli total count eventu stanowi mniej niż 3% największego counta
      w wybranych stepach, to wrzuć do Other
    </li>
    <li>
      <strong>local master step count based</strong> – jeżeli local count eventu stanowi mniej niż 3% największego counta,
      to wrzuć do Other. Liczone osobno dla każdego master stepu.
    </li>
    <li>
      <strong>dynamicznie</strong> – tak jak local, tylko możemy uwzględnić kilka master stepów jednocześnie
    </li>
  </ul>`,

    master_funnel_cnt: /* HTML */ `<p>
            Event count at each master funnel step in the selected date or
            period.
        </p>
        <p>
            <strong>Axes:</strong> X - master funnel steps in funnel order; Y -
            events.
        </p>
        <p>
            <strong>What's counted:</strong> event occurrences, not players, so
            a step revisited by the same player counts again. Low-volume and
            marginal entries are dropped.
        </p>
        <p>
            Source: <code>bi_dev.ubi-693_player_adventure_funnel_master</code>.
        </p>`,

    master_funnel_step_diff: /* HTML */ `<p>
            Drop-off at each master funnel step against the step before it.
        </p>
        <pre>
  step event count (numerator)
  ------------------------------
  previous step event count (denominator)
    </pre
        >
        <p>
            <strong>Axes:</strong> X - master funnel steps in funnel order; Y -
            share of events lost at the step, in %.
        </p>
        <p>
            Plotted as 1 minus that ratio, so 30% means three in ten events are
            lost here; the first step has no value.
        </p>
        <p>
            Source: <code>bi_dev.ubi-693_player_adventure_funnel_master</code>.
        </p>`,

    master_funnel_step_diff_first: /* HTML */ `<p>
            Cumulative drop-off from the first master funnel step to each later
            one.
        </p>
        <pre>
  step event count (numerator)
  ------------------------------
  first step event count (denominator)
    </pre
        >
        <p>
            <strong>Axes:</strong> X - master funnel steps in funnel order; Y -
            share of events lost since the first step, in %.
        </p>
        <p>
            Plotted as 1 minus that ratio; the first step is 0%, and later
            values compare their event count with it.
        </p>
        <p>
            Source: <code>bi_dev.ubi-693_player_adventure_funnel_master</code>.
        </p>`,

    master_funnel_details_cnt: /* HTML */ `<p>
            Events recorded inside the selected master steps, ranked from the
            most frequent.
        </p>
        <p>
            <strong>Axes:</strong> X - details events, ordered by count; Y -
            events.
        </p>
        <p>
            <strong>What's counted:</strong> event occurrences, not players.
            <em>Local</em> counts them only inside the selected master steps,
            <em>Total</em> across the whole adventure - the "Details events
            count strategy" setting. Rare events can be folded into
            <em>Other</em>, and the number of bars is capped by "Limit details
            steps".
        </p>
        <p>
            Source:
            <code>bi_dev.ubi-693_player_events_master_funnel_agg_cleaned</code>.
        </p>`,

    master_funnel_details_cnt_step_diff: /* HTML */ `<p>
            Drop between each details event and the one ranked above it.
        </p>
        <pre>
  event count (numerator)
  ------------------------------
  count of the event ranked above (denominator)
    </pre
        >
        <p>
            <strong>Axes:</strong> X - details events, ordered by count; Y -
            drop against the event ranked above, in %.
        </p>
        <p>
            Plotted as 1 minus that ratio. The ranking is by count, not by
            funnel order, so this compares neighbours in the ranking - not
            consecutive steps in play.
        </p>
        <p>
            Source:
            <code>bi_dev.ubi-693_player_events_master_funnel_agg_cleaned</code>.
        </p>`,

    master_funnel_details_cnt_step_diff_first: /* HTML */ `<p>
            Drop between the most frequent details event and each following one.
        </p>
        <pre>
  event count (numerator)
  ------------------------------
  top event count (denominator)
    </pre
        >
        <p>
            <strong>Axes:</strong> X - details events, ordered by count; Y -
            drop against the most frequent event, in %.
        </p>
        <p>
            Plotted as 1 minus that ratio. The ranking is by count, not by
            funnel order, so the reference bar is the most frequent event, not
            the first step in play.
        </p>
        <p>
            Source:
            <code>bi_dev.ubi-693_player_events_master_funnel_agg_cleaned</code>.
        </p>`,
} as const;
